import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { takePendingAppSetup } from '../../api/githubApp'
import { ROUTES } from '../../constants/routes'

/**
 * Own GitHub Apps created before `/github-app/setup` existed still send the
 * browser to the workspace resources page after install
 * (`?installation_id=…`), and GitHub offers no API to change an App's
 * setup URL. When this browser holds that setup, continue on the
 * connection's page; otherwise render `children` (the resources page).
 */
export function GitHubLegacySetupRedirect({
  children,
}: {
  children: React.ReactNode
}) {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [target, setTarget] = useState<string | null>(null)
  // The sessionStorage read is destructive: guard against StrictMode's
  // double effect, which would otherwise consume the id and skip the
  // redirect.
  const started = useRef(false)
  useEffect(() => {
    if (started.current) return
    started.current = true
    const id = params.get('installation_id') ? takePendingAppSetup() : null
    setTarget(id)
    if (id) void navigate(ROUTES.resourceDetail(id), { replace: true })
  }, [params, navigate])
  return target ? null : children
}
